import actionTypes from "../actionTypes";

const initialState = {};

function modal(state = initialState, action) {
  switch (action.type) {
    case actionTypes.OPEN_MODAL:
      if (!action.id) return state;
      return {
        ...state,
        [action.id]: { open: true, data: action.data ?? null },
      };
    case actionTypes.CLOSE_MODAL:
      if (!action.id) return state;
      return {
        ...state,
        [action.id]: { open: false, data: null },
      };
    default:
      return state;
  }
}

export default modal;
